export default "__VITE_ASSET__QAKJZ3Bo__"